const KEY = "cm.openSkillForum";
const EVENT = "cm-skill-forum-change";

function emit() {
  if (typeof window !== "undefined" && typeof window.dispatchEvent === "function") {
    window.dispatchEvent(new Event(EVENT));
  }
}

function normalizeForum(raw) {
  const skillId = Number(raw?.skillId) || 0;
  const skillName = (raw?.skillName || "").trim();
  if (!(skillId > 0) || !skillName) return null;
  return { skillId, skillName };
}

function readState() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return { forums: [], activeSkillId: null };
    const parsed = JSON.parse(raw);

    // Legacy Phase 1: { skillId, skillName }
    if (!Array.isArray(parsed?.forums) && parsed?.skillId != null) {
      const one = normalizeForum(parsed);
      return {
        forums: one ? [one] : [],
        activeSkillId: one ? one.skillId : null,
      };
    }

    const forums = Array.isArray(parsed?.forums)
      ? parsed.forums.map(normalizeForum).filter(Boolean)
      : [];
    let activeSkillId = Number(parsed?.activeSkillId) || null;
    if (activeSkillId && !forums.some((f) => f.skillId === activeSkillId)) {
      activeSkillId = forums.length ? forums[forums.length - 1].skillId : null;
    }
    if (!activeSkillId && forums.length) {
      activeSkillId = forums[forums.length - 1].skillId;
    }
    return { forums, activeSkillId };
  } catch {
    return { forums: [], activeSkillId: null };
  }
}

function writeState(state) {
  if (!state.forums.length) {
    sessionStorage.removeItem(KEY);
    emit();
    return;
  }
  sessionStorage.setItem(
    KEY,
    JSON.stringify({
      forums: state.forums,
      activeSkillId: state.activeSkillId,
    })
  );
  emit();
}

export function getOpenSkillForums() {
  return readState().forums.slice();
}

export function getActiveSkillForum() {
  const { forums, activeSkillId } = readState();
  return forums.find((f) => f.skillId === activeSkillId) || null;
}

/** Prefer getActiveSkillForum — kept for call-site compat */
export function getOpenSkillForum() {
  return getActiveSkillForum();
}

export function openSkillForum({ skillId, skillName }) {
  const id = Number(skillId) || 0;
  const name = (skillName || "").trim() || "Skill";
  if (!(id > 0)) return;
  const state = readState();
  const existing = state.forums.find((f) => f.skillId === id);
  if (existing) {
    existing.skillName = name;
    state.activeSkillId = id;
  } else {
    state.forums.push({ skillId: id, skillName: name });
    state.activeSkillId = id;
  }
  writeState(state);
}

export function setActiveSkillForum(skillId) {
  const id = Number(skillId) || 0;
  if (!(id > 0)) return;
  const state = readState();
  if (!state.forums.some((f) => f.skillId === id)) return;
  state.activeSkillId = id;
  writeState(state);
}

export function closeSkillForum(skillId) {
  const id = Number(skillId) || 0;
  if (!(id > 0)) return;
  const state = readState();
  const next = state.forums.filter((f) => f.skillId !== id);
  let activeSkillId = state.activeSkillId;
  if (activeSkillId === id) {
    activeSkillId = next.length ? next[next.length - 1].skillId : null;
  }
  writeState({ forums: next, activeSkillId });
}

export function subscribeSkillForum(handler) {
  window.addEventListener(EVENT, handler);
  window.addEventListener("storage", handler);
  return () => {
    window.removeEventListener(EVENT, handler);
    window.removeEventListener("storage", handler);
  };
}
